export default "__VITE_ASSET__BNle5Nb$__"